import { Moon, Sun } from 'lucide-react';

export const ThemeToggle = ({ theme, toggleTheme }) => {
    return (
        <button
            type="button"
            onClick={toggleTheme}
            aria-label="Toggle theme"
            className="inline-flex items-center justify-center w-10 h-10 rounded-xl border border-[var(--border-color)] bg-[var(--surface-color)] text-[var(--text-primary)] transition-all duration-300 hover:scale-105 hover:border-blue-500/40"
        >
            {theme === 'dark' ? (
                <Sun className="w-5 h-5" />
            ) : (
                <Moon className="w-5 h-5" />
            )}
        </button>
    );
};